import { useState, useEffect } from 'react';

var API = 'https://api.algrok.com';

export default function AlertRibbon() {
  var [alert, setAlert] = useState(null);

  useEffect(function() {
    function check() {
      fetch(API + '/health').then(function(r) { return r.json(); }).then(function(d) {
        // Parse IST time from API
        var istHm = 0;
        try {
          var parts = (d.time_ist || '').match(/T(\d+):(\d+)/);
          if (parts) istHm = parseInt(parts[1]) * 100 + parseInt(parts[2]);
        } catch(e) {}

        if (!d.ws_connected) {
          setAlert({ type: 'ws', msg: 'WebSocket disconnected', sub: 'No live data \u2014 trades blocked. Login required.' });
        } else if (!d.token_ok) {
          setAlert({ type: 'token', msg: 'Login failed', sub: 'No broker connection. Login required.' });
        } else if (d.last_tick_age > 120 && d.last_tick_age > 0 && istHm >= 915 && istHm <= 1530
                   && !(d.market_check_done && !d.market_open)) {
          // Stale-tick alert: suppressed on market-closed days (same logic as Telegram 5-min suppression).
          // No ticks are expected on a closed market, so "stale" is not actually a problem.
          // WS-disconnect + token alerts above still fire on closed days (matter for next session).
          setAlert({ type: 'stale', msg: 'Stale data \u2014 no ticks for ' + Math.round(d.last_tick_age) + 's', sub: 'Live data may be frozen.' });
        } else {
          setAlert(null);
        }
      }).catch(function() {
        setAlert({ type: 'engine', msg: 'Engine unreachable', sub: 'Cannot connect to API server.' });
      });
    }
    check();
    var id = setInterval(check, 10000);
    return function() { clearInterval(id); };
  }, []);

  if (!alert) return null;

  return (
    <div style={{
      background: '#cc0000', padding: '8px 14px', display: 'flex', alignItems: 'center', gap: 10,
      zIndex: 9999, fontFamily: "'Inter',sans-serif", flexShrink: 0
    }}>
      <span style={{ fontSize: 18, color: '#fff' }}>{'\u26A0'}</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#fff' }}>{alert.msg}</div>
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.75)' }}>{alert.sub}</div>
      </div>
      <div onClick={function() { window.location.hash = ''; window.dispatchEvent(new CustomEvent('navigate-to', { detail: 'token' })); }}
        style={{ padding: '5px 14px', borderRadius: 6, background: 'rgba(255,255,255,0.2)', color: '#fff',
          fontSize: 11, fontWeight: 700, cursor: 'pointer', border: '1px solid rgba(255,255,255,0.3)', whiteSpace: 'nowrap' }}>
        Login
      </div>
    </div>
  );
}
